import { FormControl, FormGroup, FormControlLabel, Switch } from "@mui/material";
import { BooleanFormFieldProps } from "../types";
import React from "react";

const BooleanFormField = React.memo(({ name, label, required, disabled, props }: BooleanFormFieldProps) => {
  return (
    <FormControl
      variant="standard"
      fullWidth
      sx={(theme) => ({ border: "1px solid rgba(0, 0, 0, 0.23)", padding: `${theme.spacing(2)} ${theme.spacing(3)}`, borderRadius: 1 })}
    >
      <FormGroup>
        <FormControlLabel
          sx={{ display: "flex", justifyContent: "space-between", marginLeft: 0 }}
          required={required}
          label={label}
          name={name}
          labelPlacement="start"
          control={
            <Switch
              inputProps={{
                "aria-label": "Boolean Field Label",
              }}
              name={name}
              checked={props.value || false}
              {...props}
            />
          }
          disabled={disabled || false}
        />
      </FormGroup>
    </FormControl>
  );
});

export default BooleanFormField;
